// ============================================================================
// INITIAL STATE - simulatorInitialState.js
// ============================================================================
// ./context/simulator/simulatorInitialState.js

export default {
    simulators: [],
    currentSimulator: null,
    studentSimulators: [],
    labSimulators: [],
    courseSimulators: [],
    runningSimulators: [],
    activeCount: 0,
    serialOutput: [],
    sensorReadings: {},
    gpioStates: {},
    isLoading: false,
    error: null
}